import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17b09c06"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "base-table",
  "aria-describedby": "base table with data"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { id: "th" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "hidden sm:block"
}
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "base-table__data" }
const _hoisted_6 = {
  key: 1,
  class: "base-table",
  "aria-describedby": "base table without data"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { id: "th" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "hidden sm:block"
}
const _hoisted_9 = { class: "label" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "base-table__data bar" }, null, -1))

import { computed, useSlots } from 'vue';
import type { Slot } from 'vue';
import { Props as TableColumnProps } from './BaseTableColumn.vue';

interface Props<T = Record<string, string | number | boolean>> {
  source?: T[];
  keyBy: keyof T;
  isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    source: null,
    keyBy: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



const slots = useSlots();

const cells = computed(() => {
  if (!slots.default) return [];
  const defaultSlots = slots.default();
  return defaultSlots.map((slot) => {
    type Children = {
      default?: () => ReturnType<Slot>;
    };
    const label = (slot.children as Children)?.default?.()[0].children;
    return {
      ...(slot.props as TableColumnProps),
      label,
    };
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!__props.isLoading)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _createElementVNode("thead", null, [
            _hoisted_2,
            _createElementVNode("tr", null, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.source, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: (item[__props.keyBy] as string | number)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cells), (cell) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: _normalizeClass({ 'table-cell--mobile-hidden': cell.mobilehidden }),
                    key: cell.id,
                    style: _normalizeStyle({ width: cell.width })
                  }, [
                    (index > 0)
                      ? (_openBlock(), _createElementBlock("hr", _hoisted_3))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(cell.label), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _renderSlot(_ctx.$slots, cell.id, _normalizeProps(_guardReactiveProps({ data: item[cell.id], item })), () => [
                        _createTextVNode(_toDisplayString(item[cell.id]), 1)
                      ])
                    ])
                  ], 6))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _hoisted_7,
            _createElementVNode("tr", null, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, index) => {
              return _createElementVNode("tr", { key: index }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cells), (cell) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: _normalizeClass([{ 'table-cell--mobile-hidden': cell.mobilehidden }, "loading"]),
                    key: cell.id,
                    style: _normalizeStyle([{ width: cell.width }, {"padding":"10px !important"}])
                  }, [
                    (index > 0)
                      ? (_openBlock(), _createElementBlock("hr", _hoisted_8))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(cell.label), 1),
                    _hoisted_10
                  ], 6))
                }), 128))
              ])
            }), 64))
          ])
        ]))
  ]))
}
}

})